import { render, staticRenderFns } from "./patient-update.vue?vue&type=template&id=1e1282e2&"
import script from "./patient-update.vue?vue&type=script&lang=js&"
export * from "./patient-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports